import { render } from "./TrackingPointNameBox.vue?vue&type=template&id=9988db9e&scoped=true"
import script from "./TrackingPointNameBox.vue?vue&type=script&lang=ts"
export * from "./TrackingPointNameBox.vue?vue&type=script&lang=ts"

import "./TrackingPointNameBox.vue?vue&type=style&index=0&id=9988db9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9988db9e"

export default script